import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
// tslint:disable-next-line: import-spacing
import { FiltrosOrdenAdmisionEntity, PacienteOrdenAdmisionEntity, DataOrdenSuministroAdmisionEntity } from '../../../../services/servicio-orden-admision.service';
import { EntidadEmpresarialEntity } from '../../../../services/servicio-entidad.service';
import { DataSolicitudSuministrosBodyEntity } from '../../../../services/servicio-solicitudes-suministro.service';

@Component({
  selector: 'app-reporte-orden-suministro-admision',
  templateUrl: './reporte-orden-suministro-admision.component.html',
  styleUrls: ['./reporte-orden-suministro-admision.component.css']
})
export class ReporteOrdenSuministroAdmisionComponent implements OnInit {

  loading: boolean;
  mensajeError: string;
  fechaImpresion: Date;

  public filtros: FiltrosOrdenAdmisionEntity = {};

  entidad: EntidadEmpresarialEntity;
  head: PacienteOrdenAdmisionEntity;
  groupData: {profesional: string, data: DataOrdenSuministroAdmisionEntity[]}[] = [];
  data: DataOrdenSuministroAdmisionEntity[] = [];
  totales: { valor: number, cantidad: number};

  constructor(private activatedRoute: ActivatedRoute) {
    this.activatedRoute.params.subscribe(params => {
      this.filtros.codigoBaseDatos = params['codigoBaseDatos'];
      this.filtros.uncoSede = Number(params['uncoSede']);
      this.filtros.consecutivo = params['consecutivo'];
    });
  }

  ngOnInit() {
  }

  updateLoading(value: boolean) {
    this.loading = value;
    this.mensajeError = null;
  }

  updateError(error: string) {
    this.loading = false;
    this.mensajeError = error;
  }

  updateData( response: { entidad: EntidadEmpresarialEntity, data: DataOrdenSuministroAdmisionEntity[]}) {
    this.mensajeError = null;
    this.loading = false;
    this.fechaImpresion = new Date();

    this.entidad = response.entidad;
    this.head = this.getHeadData(response.data);
    this.groupData = this.getGroupData(response.data);
    this.totales = this.getTotal();
    // console.log(this.totales);
  }

  getTotal(): { valor: number, cantidad: number } {
    let value = 0;
    let cantidad = 0;
    if (this.groupData && this.groupData.length > 0) {
      this.groupData.forEach((g: any) => {
        g.data.forEach((d: DataOrdenSuministroAdmisionEntity) => {
          value += (d.cantidad) * (d.valorUnitario);
          cantidad++;
        });
      });
    }
    return { valor : value, cantidad : cantidad};
  }

  // Auxiliares

  isPrepare() {
    return !this.loading && !this.mensajeError;
  }

  isPrepareData() {
    return this.isPrepare() && this.groupData && this.groupData.length > 0;
  }

  getHeadData(data: DataOrdenSuministroAdmisionEntity[]): PacienteOrdenAdmisionEntity {
    let paciente: PacienteOrdenAdmisionEntity;
    if (data && data.length > 0) {
      const d = data[0];
      paciente = {
        afiliado : d.afiliado,
        empresa : d.empresa,
        consecutivoAdmision : d.consecutivoAdmision,
        edad : d.edad,
        fechaAdmision : d.fechaAdmision,
        fechaNacimiento : d.fechaNacimiento,
        fechaSalidaAdmision : d.fechaSalidaAdmision,
        numeroIdentificacion : d.numeroIdentificacion,
        puntoAtencion : d.puntoAtencion,
        rangoSalarial : d.rangoSalarial,
        sede : d.sede,
        tipoAfiliado : d.tipoAfiliado,
        tipoDocumento : d.tipoDocumento
      };
    }
    return paciente;
  }

  getGroupData(data: DataOrdenSuministroAdmisionEntity[]): { profesional: string, data: DataOrdenSuministroAdmisionEntity[] }[] {
    let group: {profesional: string, data: DataOrdenSuministroAdmisionEntity[]}[] = [];

    if (data && data.length > 0) {
      data.forEach((d: DataOrdenSuministroAdmisionEntity) => {
        const profesional = d.profesionalOrdena;
        const index = group.findIndex((g: {profesional: string, data: DataOrdenSuministroAdmisionEntity[]}) => {
          return g.profesional === profesional;
        });

        if (index === -1) {
          const new_group: {profesional: string, data: DataOrdenSuministroAdmisionEntity[]} = {
            profesional,
            data : [d]
          };
          group.push(new_group);
        } else {
          group[index].data.push(d);
        }
      });

      if (group && group.length > 0) {
        group = group.sort((a: any, b: any) => {
          if (a.profesional < b.profesional) { return -1; }
          if (a.profesional > b.profesional) { return 1; }
          return 0;
        });
      }

      return group;
    }

    return group;
  }

}


